export default __webpack_public_path__ + "static/media/721.addc1a80.png";